<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>

		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		gate_create
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '设备名称',
					model: 'Name'
				}, {
					name: '设备编号',
					model: 'Num'
				}],
				inputmodel: {
					Name: '',
					Num: ''
				},
				rules: {},
				options: [],
			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							gate_create(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				// this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};

		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>